/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateProjectStagesCommand } from '../../models/create-project-stages-command';
import { CreateProjectStagesCommandResult } from '../../models/create-project-stages-command-result';

export interface ApiProjectStagesCreateProjectStagesPatch$Plain$Params {
      body?: CreateProjectStagesCommand
}

export function apiProjectStagesCreateProjectStagesPatch$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectStagesCreateProjectStagesPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectStagesCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectStagesCreateProjectStagesPatch$Plain.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateProjectStagesCommandResult>;
    })
  );
}

apiProjectStagesCreateProjectStagesPatch$Plain.PATH = '/api/ProjectStages/CreateProjectStages';
